<template>
  <div class="schedule">
    <div class="docter">
      <el-input class="docter_search" v-model.trim="doctorSearch" prefix-icon="el-icon-search" placeholder="搜索医生" clearable @input="searchDoctor"></el-input>
      <div class="doctor_list" ref="doctor_list">
        <div v-for="item in docterList" :key="item.doctorId" :class="{ doctor_item: true, active: item.doctorId === doctorActiveId }" @click="onDoctor(item)">
          <img class="doctor_img" src="../../../assets/images/doctor_icon.png" />
          <span class="doctor_name">{{ item.doctorName }}</span>
        </div>
      </div>
    </div>
    <div class="schedule_info">
      <Calendar v-if="!['', null, undefined].includes(doctorActiveId)" ref="calendar" :doctorId="doctorActiveId" :doctorName="doctorActiveName" @cache="cacheState"></Calendar>
    </div>
  </div>
</template>

<script>
  import Calendar from './components/calendar.vue'
  import { debounce } from 'lodash'
  import { queryDoctorDept } from "@/api/doctor"
  export default {
    name: "Schedule",
    components: {  Calendar },
    data() {
      return {
        doctorSearch: '',
        docterListSource: [],
        docterList: [],
        doctorActiveId: '',
        doctorActiveName: ''
      }
    },
    async created() {
      await this.getDoctorList()
      if (window.sessionStorage.getItem('scheduleInfo')) {
        const scheduleInfo = JSON.parse(window.sessionStorage.getItem('scheduleInfo'))

        this.doctorSearch = scheduleInfo.doctorSearch
        this.searchDoctor()

        this.doctorActiveId = scheduleInfo.doctorId
        this.doctorActiveName = scheduleInfo.doctorName
        this.$nextTick(() => {
          this.$refs['doctor_list'].scrollTop = scheduleInfo.doctorListScrollTop
          this.$refs['calendar'].init(scheduleInfo.type, scheduleInfo.date)
          window.sessionStorage.removeItem('scheduleInfo')
        })
      }
    },
    methods: {
      async getDoctorList () {
        const res = await queryDoctorDept({ pageNum: 1, type: 0, status: '0' })
        if (res.code === 200) {
          const list = res.rows.filter(v => { return v.status === '0' })
          this.docterListSource = list
          this.docterList = list
        }
      },
      searchDoctor: debounce(function() {
        if (['', undefined, null].includes(this.doctorSearch)) {
          this.docterList = this.docterListSource
        } else {
          this.docterList = this.docterListSource.filter(item => {
            return (item.doctorName && item.doctorName.includes(this.doctorSearch)) || (item.userCode && item.userCode.includes(this.doctorSearch))
          })
        }
      }, 500),
      onDoctor (row) {
        this.doctorActiveId = row.doctorId
        this.doctorActiveName = row.doctorName
        this.$nextTick(() => {
          this.$refs['calendar'].init()
        })
      },
      cacheState (info) {
        const doctorListScrollTop = this.$refs['doctor_list'].scrollTop
        const scheduleInfo = {
          doctorSearch: this.doctorSearch,
          doctorId: this.doctorActiveId,
          doctorName: this.doctorActiveName,
          doctorListScrollTop: doctorListScrollTop,
          type: info.type,
          currentDate: info.currentDate
        }
        window.sessionStorage.setItem('scheduleInfo', JSON.stringify(scheduleInfo))
      }
    }
  };
</script>

<style lang="less" scoped>
  .schedule {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    height: 100%;
  }

  .docter {
    flex-shrink: 0;
    box-sizing: border-box;
    padding: 18px 12px;
    width: 200px;
    height: 100%;
    background-color: #FAFBFC;
    border-right: 1px solid #E0E0E0;
    overflow: hidden;
  }

  .docter_search {
    width: 100%;
    height: 32px;
  }

  .docter_search /deep/ .el-input__inner {
    border-radius: 4px;
  }

  .doctor_list {
    margin: 12px 0 0 0;
    width: calc(100% + 6px);
    height: calc(100% - 32px - 12px);
    overflow-x: hidden;
    overflow-y: auto;
  }

  .doctor_item {
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 6px;
    width: 100%;
    height: 40px;
    border-radius: 4px;
    cursor: pointer;
  }

  .doctor_img {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    overflow: hidden;
  }

  .doctor_name {
    margin: 0 0 0 8px;
    width: calc(100% - 18px - 8px);
    font-size: 14px;
    color: #000000;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .doctor_item.active {
    background-color: #1890FF;
  }

  .doctor_item.active .doctor_name {
    color: #FFFFFF;
  }

  .schedule_info {
    flex-grow: 1;
    box-sizing: border-box;
    padding: 20px 16px;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }
</style>